import axios from './index.js'
import Vue from 'vue'
var el = new Vue({})

const newAxios = {
  /* post请求
	   @param url{string} 请求地址
	   @param params{object} 请求参数
	   @param extraParams{string|function} 错误回调函数，或者是config参数
	   @param noLoading{boolean} true:不显示加载框,false:显示加载框
	 */
  post (url, params, extraParams, noLoading) {
    var config = typeof extraParams === 'object' ? extraParams : {}
    return axios
      .post(url, params, config)
      .then(res => {
        return res
      })
      .catch(data => {
        return catchCallback(url, extraParams, data)
      })
  },
  /* get请求
	   @param url{string} 请求地址
	   @param params{object} 请求参数
	   @param extraParams{string|function} 错误回调函数，或者是config参数
	   @param noLoading{boolean} true:不显示加载框,false:显示加载框
	 */
  get (url, params, extraParams, noLoading) {
    var config = typeof extraParams === 'object' ? extraParams : {}
    return axios
      .get(url, {
        params: params,
        ...config
      })
      .then(res => {
        return res
      })
      .catch(data => {
        return catchCallback(url, extraParams, data)
      })
  },
  delete: axios.delete,
  put: axios.put,
  all: axios.all,
  spread: axios.spread
}

function catchCallback (url, extraParams, data) {
  // console.log(url);
  if (extraParams && typeof extraParams !== 'object') {
    extraParams(data, data.mess || data.msg || '请求失败,请稍后重试')
  } else {
    if (data.code1 == 401) {
      // 无权限
      // console.log(data.mess)
    } else {
      messtips(data.mess)
    }
  }
  return new Promise(() => {
    console.log(url, data.mess)
  })
}
function messtips (mess) {
  el.$message.error(mess || '请求失败,请稍后重试')
}
export default newAxios



// WEBPACK FOOTER //
// ./src/axios/newAxios.js